export default __webpack_public_path__ + "static/media/template23.1faa8a21.svg";